export default __webpack_public_path__ + "static/media/m.f126522f.jpg";